import { useEffect, useMemo, useState } from 'react';
import { fetchExportLogs } from '../services/export.api';
import { mapExportRow } from '../utils/export.helpers';

export function useExportLogs(dateRange) {
  const [raw, setRaw] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch all logs once on mount
  useEffect(() => {
    const ac = new AbortController();
    (async () => {
      try {
        setLoading(true);
        const data = await fetchExportLogs({}, ac.signal);
        setRaw(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error('useExportLogs:init', e);
        setRaw([]);
      } finally {
        setLoading(false);
      }
    })();
    return () => ac.abort();
  }, []);

  // Filter by dateRange client-side
  const rows = useMemo(() => {
    const mapped = (raw || []).map(row => row ? mapExportRow(row) : undefined).filter(Boolean);
    if (!dateRange || (!dateRange.start && !dateRange.end)) {
      return mapped;
    }
    return mapped.filter(row => {
      if (!row.date) return false;
      if (dateRange.start && row.date < dateRange.start) return false;
      if (dateRange.end && row.date > dateRange.end) return false;
      return true;
    });
  }, [raw, dateRange]);

  return { rows, loading, refreshing: false };
}
